import { useEffect } from 'react';
import { TModal } from '../Modal';
import { focus, focusSelector, getFocusSelector } from '@apia/util';

export function useInitialFocus({
  isOpenInner,
  initialFocusConfiguration,
  initialFocusGetter,
  initialFocusRef,
  noFocus,
  parentElement,
}: { isOpenInner: boolean; parentElement?: HTMLElement | null } & Pick<
  TModal,
  | 'noFocus'
  | 'initialFocusGetter'
  | 'initialFocusRef'
  | 'initialFocusConfiguration'
>) {
  useEffect(
    () => {
      if (!noFocus && isOpenInner) {
        if (parentElement) {
          void focus.on(
            () => {
              if (initialFocusGetter) return initialFocusGetter(parentElement);
              if (initialFocusRef?.current)
                return (
                  (initialFocusRef?.current || parentElement) as HTMLElement
                ).querySelector(focusSelector) as HTMLElement;
              return parentElement.querySelector(
                getFocusSelector(':not(.modal__closeButton)'),
              ) as HTMLElement;
            },
            { ...initialFocusConfiguration, focusEvenWhenScreenLocked: true },
          );
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [parentElement],
  );
}
